import {FC, useCallback, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import {Field, ErrorMessage, useField} from 'formik'
import {useDropzone} from 'react-dropzone'
import {AnimaBaixo, AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import Table from './table'

type Data = {
  descricao: string
  url: string
  index: number
}

const Step3: FC = () => {
  const intl = useIntl()
  const [, , helpers3] = useField('path')
  const [, , setLink] = useField('links')
  const [descricao, setDescricao] = useState('')
  const [url, setUrl] = useState('')
  const [data, setData] = useState<Data[]>([])
  const [index, setIndex] = useState(1)
  let arquivo: any = []

  const onDrop = useCallback((acceptedFiles: any) => {
    if (acceptedFiles.length > 1) {
      arquivo.forEach((element: any) => {
        acceptedFiles.push(element)
      })
    } else {
      if (arquivo.length > 0) {
        arquivo.forEach((element: any) => {
          acceptedFiles.push(element)
        })
        arquivo.push(acceptedFiles[0])
      } else {
        arquivo.push(acceptedFiles[0])
      }
    }
    helpers3.setValue(acceptedFiles)
    // eslint-disable-next-line
  }, [])

  const {getRootProps, getInputProps, isDragActive, acceptedFiles} = useDropzone({onDrop})

  const files = acceptedFiles.map((file: any) => (
    <AnimaBaixo>
      <p className='text-primary mt-10 dropzone'>
        <img alt='' className='w-30px me-3' src={toAbsoluteUrl('/media/svg/files/pdf.svg')} />{' '}
        {file.name} <span className='text-gray-600'>- {file.size} bytes</span>
      </p>
    </AnimaBaixo>
  ))

  const handleSubmit = (e: any) => {
    // console.log('handleSubmit', e)
    if (e) {
      e.preventDefault()
      setData([...data, {descricao, url, index}])
      setDescricao('')
      setUrl('')
      setIndex(index + 1)
      setLink.setValue([...data, {descricao, url, index}])
    }
  }

  const handleDelete = (index: any) => {
    if (index) {
      setData(data.filter((item) => item.index !== index))
      setLink.setValue(data.filter((item) => item.index !== index))
    }
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-4'>
          <h2 className='fw-bolder d-flex align-items-center text-dark'>
            {intl.formatMessage({id: 'CONDITIONINGS.STEP3'})}
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title={intl.formatMessage({id: 'CONDITIONINGS.STEP3LEG'})}
            ></i>
          </h2>

          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'CONDITIONINGS.STEP3SUB'})}
          </div>
        </div>

        <div className='fv-row'>
          <div className='col-lg-12 mt-3'>
            {/* inicio teste dropzone */}
            <div className='col-lg-12 mt-4'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.PROOF'})}
              </label>
              <div className='dropzone  my-1' {...getRootProps()}>
                <div className='dz-message needsclick'>
                  <i className='bi bi-file-earmark-arrow-up text-primary fs-3x'></i>
                  <div className='ms-4'>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                        {intl.formatMessage({id: 'DROPZONE.TITLE_DRAG'})}
                      </h3>
                    ) : (
                      <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                        {intl.formatMessage({id: 'DROPZONE.TITLE'})}
                      </h3>
                    )}

                    <label
                      htmlFor='license_documentation'
                      className='fs-7 fw-semibold text-gray-400'
                    >
                      {intl.formatMessage({id: 'DROPZONE.SUBTITLE'})}
                    </label>
                  </div>
                </div>

                <p> {files}</p>
              </div>
            </div>
          </div>

          {/* inicio observeção */}
          <div className='col-lg-12'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
            </label>
            <div className='d-flex position-relative my-1'>
              <Field
                as='textarea'
                name='observation'
                className='form-control form-control-lg form-control-solid'
                placeholder={intl.formatMessage({id: 'CONDITIONINGS.OBSERVATION'})}
                rows={2}
              />
              <div className='text-danger mt-2'>
                <ErrorMessage name='observation' />
              </div>
            </div>
          </div>

          {/* MODAL ADICIONAR LINKS */}
          <button
            type='button'
            className='btn btn-sm btn-primary my-4'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            Adicionar Link Externo
          </button>
          <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title mt-n4'>Adicionar Link Externo</h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-0'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>
                <div className='card-body border-top px-4 mx-4 mt-n4'>
                  {/* <form> */}
                  <div className='col-lg-12'>
                    <div className='row'>
                      {/* Inicio da 1 linha */}
                      <div className='row mb-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                        </label>

                        <textarea
                          rows={2}
                          className='form-control form-control-lg form-control-solid'
                          title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                          placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                          value={descricao}
                          onChange={(e) => setDescricao(e.target.value)}
                        />
                      </div>

                      {/* Inicio da 1 linha */}
                      <div className='row mb-3'>
                        <label className='col-lg-12 col-form-label fw-bold fs-6'>
                          URL <i className='fa-solid fa-link text-dark px-1'></i>
                          {/* {intl.formatMessage({id: 'COMMON.DESCRIPTION'})} */}
                        </label>
                        <input
                          placeholder='https://example.com'
                          pattern='https://.*'
                          required
                          className='form-control form-control-lg form-control-solid'
                          value={url}
                          onChange={(e) => setUrl(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='d-flex justify-content-end py-6'>
                    <button
                      type='button'
                      className='btn btn-sm btn-primary'
                      data-bs-dismiss='modal'
                      onClick={(e) => handleSubmit(e)}
                    >
                      {intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                    </button>
                  </div>
                  {/* </form> */}
                </div>
              </div>
            </div>
          </div>

          {/* INICIO TABELA */}
          <div>
            <Table data={data} onDelete={handleDelete} />
          </div>
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step3}
